import { render, staticRenderFns } from "./ProductDimensions.vue?vue&type=template&id=43a2aa2a&"
import script from "./ProductDimensions.vue?vue&type=script&lang=ts&"
export * from "./ProductDimensions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports